import React, { useEffect } from 'react'
import { Slider, Text, View } from '@/components'
import { variantProvider } from '@/app'

type SliderOnboardingProps = {
  label?: string
  labelVariants?: string[]
  min: number
  max: number
  trackMarks?: Record<number, string>
  value?: number
  defaultValue?: number
  onValueChange?: (val: number) => void
}

export function SliderOnboarding({
  label,
  labelVariants,
  min,
  max,
  trackMarks,
  value,
  defaultValue = 3,
  onValueChange,
  ...props
}: SliderOnboardingProps) {

    useEffect(() => {
    onValueChange(defaultValue)
  }, [])

  if (min == null || max == null) return null

  const steps = Array.from({ length: max - min + 1 }, (_, i) => i + min)

  return (
    <View style={styles.sliderContainer} {...props}>
      {label && (
        <Text
          variants={[
            'p2',
            'color:neutral5',
            'marginBottom:4',
            ...(labelVariants ?? []),
          ]}
          text={label}
        />
      )}

      <View style={styles.sliderWrapper}>
        <Slider
          value={[value ?? defaultValue]}
          onValueChange={(value: number[]) => onValueChange(value?.[0])}
          min={min}
          max={max}
          step={1}
          debugName="onboarding-slider"
          variants={['onboarding']}
        />
        <View style={styles.numbersWrapper} variants={['center']}>
          {steps.map((step) => (
            <Text key={step} variants={['p4', 'neutral-9']} text={String(step)} />
          ))}
        </View>

        {trackMarks && (
          <View style={styles.trackMarksWrapper}>
            {steps.map((step) => (
              <Text
                key={step}
                variants={['p3', 'neutral-9']}
                text={trackMarks[step] ?? ''}
              />
            ))}
          </View>
        )}
      </View>
    </View>
  )
}

const styles = variantProvider.createComponentStyle((theme) => {
  return {
    sliderContainer: {
      ...theme.presets.flex,
      ...theme.presets.column,
      minHeight: 80,
    },
    sliderWrapper: {
      ...theme.presets.flex,
      ...theme.presets.column,
      ...theme.presets.relative,
      ...theme.presets.fullWidth,
    },
    numbersWrapper: {
      ...theme.presets.flex,
      ...theme.presets.row,
      ...theme.presets.justifySpaceBetween,
      ...theme.presets.alignSelfCenter,
      width: '95%',
      position: 'absolute',
      top: -20,
    },
    trackMarksWrapper: {
      ...theme.presets.flex,
      ...theme.presets.row,
      ...theme.presets.justifySpaceBetween,
      ...theme.presets.fullWidth,
      position: 'absolute',
      top: 40,
    },
  }
}, true)
